import React, { useContext, useState, useEffect } from "react";
import { AppContext } from "../../App";
import "./Price.scss";
import { URL } from "../../constants/url";
import { ButtonLoading } from "../loading/Loading";

const Price = () => {
  const { priceOfTime, setpriceOfTime } = useContext(AppContext);
  const [Price, setPrice] = useState(priceOfTime.Price);
  const [PriceVip, setPriceVip] = useState(priceOfTime.PriceVip);
  const [successMessage, setSuccessMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setPrice(priceOfTime.Price);
    setPriceVip(priceOfTime.PriceVip);
  }, [priceOfTime]);

  const updatePrices = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${URL}/api/prices`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ Price: Price, PriceVip: PriceVip }),
      });
      const data = await response.json();
      setpriceOfTime(data);
      setSuccessMessage("Prices updated successfully!");
      setTimeout(() => {
        setSuccessMessage(null);
      }, 2000);
      setIsLoading(false);
    } catch (error) {
      console.error("Error updating prices:", error);
      setSuccessMessage(null);
      setIsLoading(false);
    }
  };

  return (
    <div className="form-container">
      <div>
        <div>
          <label>Price: </label>
          <input
            type="number"
            value={Price}
            onChange={(e) => setPrice(e.target.value)}
            className="input-field"
          />
        </div>
        <div>
          <label>Price VIP: </label>
          <input
            type="number"
            value={PriceVip}
            onChange={(e) => setPriceVip(e.target.value)}
            className="input-field"
          />
        </div>
        <button onClick={updatePrices} className="button">
          {isLoading === true ? <ButtonLoading /> : "Update Prices"}
        </button>
        <div className="frame-success-message">
          {""}
          {successMessage && (
            <p className="success-message">{successMessage}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Price;
